var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{staticClass:"px-4",attrs:{"color":_vm.color,"block":_vm.block}},[_vm._v(_vm._s(_vm.text)),(_vm.loading)?_c('span',{staticClass:"ml-2"},[_c('img',{staticClass:"gif",attrs:{"src":"/img/loading-sm.gif"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }